@if (!oregType() || oregType() === 'isWorksite') {
  <lib-question-worksite
    [labelPrefix]="labelPrefix()"
    [questionForm]="questionForm()"
    [question]="question()"
    [repeaterGroupId]="repeaterGroupId()"
    [isChangeRequest]="isChangeRequest()"
  ></lib-question-worksite>
} @else {
  <lib-question-account
    [labelPrefix]="labelPrefix()"
    [questionForm]="questionForm()"
    [question]="question()"
    [repeaterGroupId]="repeaterGroupId()"
  >
  </lib-question-account>
}
